"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var jsx_runtime_1 = require("react/jsx-runtime");
var use_context_selector_1 = require("use-context-selector");
var Pagination_1 = tslib_1.__importDefault(require("../../Pagination"));
var Portal_1 = tslib_1.__importDefault(require("../../Portal"));
var context_1 = tslib_1.__importDefault(require("../context"));
var TablePagination = function (_a) {
    var disabled = _a.disabled, props = tslib_1.__rest(_a, ["disabled"]);
    var paginationPortal = (0, use_context_selector_1.useContextSelector)(context_1.default, function (context) { return context.paginationPortal; });
    var loading = (0, use_context_selector_1.useContextSelector)(context_1.default, function (context) { return context.loading; });
    var total = (0, use_context_selector_1.useContextSelector)(context_1.default, function (context) { return context.total; });
    return ((0, jsx_runtime_1.jsx)(Portal_1.default, tslib_1.__assign({ target: paginationPortal }, { children: (0, jsx_runtime_1.jsx)(Pagination_1.default, tslib_1.__assign({}, props, { total: total !== null && total !== void 0 ? total : 0, mode: 'table', disabled: disabled !== null && disabled !== void 0 ? disabled : loading, className: 'hts-table-pagination' })) })));
};
/**
 * @deprecated Use Table from Antd
 * https://ant.design/components/table/
 */
exports.default = TablePagination;
